import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ACTOR_VOICES_QUERY_KEYS } from "Actors/Api/Queries/actorVoicesQueryKeys";
import {
  ActorVoiceTrainingFileType,
  postActorsActorIDActorVoicesActorVoiceIDTrainingFiles,
  type UploadActorVoiceTrainingFileRequest,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getResourcePath,
  Resources,
} from "Infrastructure/Translations/Resources";

interface UploadTrainingFileParams {
  actorVoiceID: string;
  file: File;
  type?: ActorVoiceTrainingFileType;
}

export function useUploadActorVoiceTrainingFileMutation(actorID: string) {
  const queryClient = useQueryClient();

  const mutationFn = processResponse(
    ({
      actorVoiceID,
      file,
      type = ActorVoiceTrainingFileType.Training,
    }: UploadTrainingFileParams) => {
      const request: UploadActorVoiceTrainingFileRequest = { file, type };
      return postActorsActorIDActorVoicesActorVoiceIDTrainingFiles(
        request,
        actorID,
        actorVoiceID,
      );
    },
    {
      translationPrefix: getResourcePath(
        Resources.ApiErrors.UploadActorVoiceTrainingFile,
      ),
    },
  );

  return useMutation({
    mutationFn,
    onSuccess: (_, { actorVoiceID }) => {
      queryClient.invalidateQueries({
        queryKey: ACTOR_VOICES_QUERY_KEYS.detail(actorID, actorVoiceID),
      });
    },
  });
}
